// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1k7gx","detailsBorder":"styles_detailsBorder__3P4Kp"};